/** Triggered alerts data for the Alerts Hub. */
export const MOCK_TRIGGERED_ALERTS = [];

export const MOCK_ORIGINS = ['All origins', 'Chile', 'Ica, Peru', 'Spain', 'Mexico'];

export const MOCK_WEEK_PRESETS = [
  { id: '4w', label: 'Last 4 weeks' },
  { id: '2w', label: 'Last 2 weeks' },
  { id: '1w', label: 'This week' },
];
